import { bindable, customElement } from 'aurelia';
import template from './bulk-date-modal.html';

function localDateValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

@customElement({ name: 'bulk-date-modal', template })
export class BulkDateModal {
  @bindable public count = 0;
  @bindable public busy = false;
  @bindable public confirmed!: (date: string) => void;
  @bindable public closed!: () => void;

  public selectedDate = '';

  public binding(): void {
    this.selectedDate = localDateValue(new Date());
  }

  public confirm(): void {
    if (this.busy || !/^\d{4}-\d{2}-\d{2}$/.test(this.selectedDate)) return;
    this.confirmed(this.selectedDate);
  }

  public close(): void {
    if (!this.busy) this.closed();
  }
}
